<template>
  <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
    <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editPackage" title="Revisar Pedido" />
    <feather-icon icon="RefreshCcwIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="resetLabel" title="Atualizar dados da etiqueta" />
  </div>
</template>
<script>
export default {
  name: 'CellRendererActions',
  methods: {
    editPackage() {
      this.$router.push("/package/package-edit/" + this.params.data.id).catch(() => {})
    },
    submitPackage() {

      this.$vs.loading();
      let package_id = this.params.data.id;

      this.$store.dispatch("packageManagement/registerLabels", package_id)
        .then(res => {
          console.log(res)
          this.$vs.loading.close()
          document.location.href = res.data.url
        })
        .catch(err => {
          console.error({ err: err.response })
        })
    },
    resetLabel() {
      this.$vs.loading();
      let id = this.params.data.id;
      this.$store.dispatch("packageManagement/updatePackage", [id])
        .then(res => {
          console.log({ res })

          const carrier = res.data.tracking.carrier;
          const label_error = res.data.tracking.label_error;
          this.$vs.loading.close();

          if (carrier == 'CORREIOS' && label_error == "") {

            this.$vs.notify({
              title: 'Etiqueta do pedido atualizada!',
              time: 20000,
              text: 'Em alguns minutos o pdf estara disponivel!',
              color: 'success',
              iconPack: 'feather',
              icon: 'icon-check'
            })

          } else {

            this.$vs.notify({
              time: 20000,
              title: 'Etiqueta desvinculada, porém houve um <strong>erro</strong> na geração da etiqueta:',
              text: `${label_error}`,
              color: 'danger',
              iconPack: 'feather',
              icon: 'icon-alert-circle'
            })

          }
        })
        .catch(err => {

          this.$vs.loading.close();
          this.$vs.notify({
            time: 20000,
            title: 'Atenção',
            text: `${err.response.data.message}`,
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-circle'
          })

        })

    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm Delete`,
        text: `You are about to delete "${this.params.data.username}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      })
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      this.showDeleteSuccess()

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.params.data.id)
      //   .then(()   => { this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    }
  }
}

</script>
